import React from 'react';
import { FiPhone, FiMessageCircle, FiCalendar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useData } from '../contexts/DataContext';

const FinalCTA = () => {
  const { settings } = useData();
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-emerald-600 to-emerald-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="space-y-4">
            <h2 className="text-4xl lg:text-5xl font-bold leading-tight">
              Start Your Pain-Free Life Today
            </h2>
            <p className="text-xl lg:text-2xl text-emerald-100">
              Don't let pain control your life any longer. Join 30,000+ patients who chose 
              natural healing and found lasting relief.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 lg:p-8 border border-white/20">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="text-3xl lg:text-4xl font-bold text-white mb-2">15+</div>
                <div className="text-emerald-100">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl lg:text-4xl font-bold text-white mb-2">30K+</div>
                <div className="text-emerald-100">Successful Treatments</div>
              </div>
              <div className="text-center">
                <div className="text-3xl lg:text-4xl font-bold text-white mb-2">4.9★</div>
                <div className="text-emerald-100">Patient Rating</div>
              </div>
            </div>

            <div className="text-center mb-8">
              <div className="inline-flex items-center space-x-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-semibold">
                <SafeIcon icon={FiCalendar} className="w-4 h-4" />
                <span>Limited Appointments Available - Book Now</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white hover:bg-gray-50 text-emerald-600 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center space-x-2">
                <SafeIcon icon={FiCalendar} className="w-5 h-5" />
                <span>Book Appointment</span>
              </button>
              <a href={`tel:${settings.contact_phone || settings.phone1 || '9876543210'}`} 
                 className="bg-emerald-500 hover:bg-emerald-400 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2">
                <SafeIcon icon={FiPhone} className="w-5 h-5" />
                <span>Call Now</span>
              </a>
              <a href={`https://wa.me/${settings.whatsapp || settings.phone1 || '919876543210'}`} 
                 className="bg-green-500 hover:bg-green-400 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2">
                <SafeIcon icon={FiMessageCircle} className="w-5 h-5" />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>

          <div className="space-y-4 text-center">
            <p className="text-emerald-100 text-lg">
              🔒 No Surgery • No Medicine • No Hospitalization • Fast Recovery
            </p>
            <p className="text-emerald-200">
              Trusted by patients across Mumbai, Thane, Pune, Nashik, and Aurangabad
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;